const Pagination = ({
  currentPage,
  totalPages,
  onPageChange
}) => {

  return (

    <div className="flex justify-center gap-2 mt-12">

      <button
        disabled={currentPage === 1}
        onClick={() =>
          onPageChange(currentPage - 1)
        }
      >
        Previous
      </button>

      {[...Array(totalPages)].map((_, index) => (

        <button
          key={index}
          onClick={() =>
            onPageChange(index + 1)
          }
        >
          {index + 1}
        </button>

      ))}

      <button
        disabled={currentPage === totalPages}
        onClick={() =>
          onPageChange(currentPage + 1)
        }
      >
        Next
      </button>

    </div>

  );

};

export default Pagination